import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import { Field } from './Field.tsx';
import styles from './Input.module.css';

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'className'> {
  readonly label: string;
  readonly hint?: ReactNode | undefined;
  readonly error?: string | null | undefined;
  readonly aside?: ReactNode | undefined;
  readonly labelHidden?: boolean | undefined;
  /** Control at the inside end of the field, e.g. a reveal-password button. */
  readonly trailing?: ReactNode | undefined;
  readonly className?: string | undefined;
  readonly ref?: Ref<HTMLInputElement> | undefined;
}

export const TextField = ({
  label,
  hint,
  error,
  aside,
  labelHidden,
  trailing,
  className,
  ...input
}: TextFieldProps) => (
  <Field
    label={label}
    hint={hint}
    error={error}
    aside={aside}
    labelHidden={labelHidden}
    className={className}
  >
    {(control) =>
      trailing ? (
        <div className={styles.withTrailing}>
          <input className={styles.control} {...control} {...input} />
          <span className={styles.trailing}>{trailing}</span>
        </div>
      ) : (
        <input className={styles.control} {...control} {...input} />
      )
    }
  </Field>
);
